export class LoginSliderImagesProperties {
  id: number = 0;
  imageName: string = "";
  logo: string = "";
  status: string = "";
  sliderLogoName: string = "";
  userId: number = 0;

}
